<div class="row" *ngIf="customer">
  <app-customer-moderation-create
    *ngIf="customer.isCreate"
    [customer]="customer"
    (approveCustomer)="onApprove($event)"
    (rejectCustomer)="onReject($event)"
  ></app-customer-moderation-create>

  <div class="customer-edit-container" *ngIf="!customer.isCreate">
    <app-customer-moderation-edit
      [customerId]="customerId"
      [customer]="customer"
      (approveCustomer)="onApprove($event)"
      (rejectCustomer)="onReject($event)"
      (updateData)="getCustomerData(customerId)"
    ></app-customer-moderation-edit>
  </div>
</div>
